import Vue from 'vue';
import Router from 'vue-router';

import Panel from '../components/Panel';

import Login from '../components/pages/Login';
import TireStorage from '../components/pages/TireStorage';
import TireStorageEmpty from '../components/pages/TireStorageEmpty';
import CustomerIndex from '../components/pages/CustomerIndex';
import CustomerShow from '../components/pages/CustomerShow';
import CarIndex from '../components/pages/CarIndex';
import CarShow from '../components/pages/CarShow';
import Invoicing from '../components/pages/Invoicing';
import UserIndex from '../components/pages/UserIndex';
import UserEdit from '../components/pages/UserEdit';
import LocationSummary from "@/components/pages/LocationSummary";
import SmsCampaign from "@/components/pages/SmsCampaign";
import SmsLog from "@/components/pages/SmsLog";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/panel',
            component: Panel,
            children: [
                // {
                //     path: '/',
                //     name: 'TireStorage',
                //     component: TireStorage
                // },

                {
                    path: '/customers',
                    name: 'CustomerIndex',
                    component: CustomerIndex
                },
                {
                    path: '/customers/:id',
                    name: 'CustomerShow',
                    component: CustomerShow
                },

                {
                    path: '/cars',
                    name: 'CarIndex',
                    component: CarIndex
                },
                {
                    path: '/cars/:id',
                    name: 'CarShow',
                    component: CarShow,
                    children: [
                        {
                            path: 'empty',
                            name: 'TireStorageEmpty',
                            component: TireStorageEmpty
                        },
                        {
                            path: 'tires/create',
                            name: 'TireStorageCreate',
                            component: TireStorage
                        },
                        {
                            path: 'tires/:storage',
                            name: 'TireStorage',
                            component: TireStorage
                        }
                    ]
                },
                {
                    path: '/invoicing',
                    name: 'Invoicing',
                    component: Invoicing
                },
                {
                    path: '/users',
                    name: 'UserIndex',
                    component: UserIndex
                },
                {
                    path: '/users/create',
                    name: 'UserCreate',
                    component: UserEdit
                },
                {
                    path: '/users/:id',
                    name: 'UserEdit',
                    component: UserEdit
                },
                {
                    path: '/locations',
                    name: 'LocationSummary',
                    component: LocationSummary
                },
                {
                    path: '/campaign',
                    name: 'SmsCampaign',
                    component: SmsCampaign
                },
                {
                    path: '/sms-log',
                    name: 'SmsLog',
                    component: SmsLog
                }
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            if (savedPosition === null) return;
            setTimeout(() => {
                resolve(savedPosition)
            }, 500);
        })
    }
})
